module.exports = __webpack_public_path__ + "static/media/3.4763c30f.jpg";